export const N62 = {
    "columns": 3,
    "rows": 1,
    "visual": {
        "id": 14,
        "type": "summary",
        "colorTheme": "colorTheme1",
        "title": "Sales Performance Summary",
        "binding": {
            "data": {
                "title": '',
                "value": '',
                "displayTarget": true,
                "endpoint": "N62",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {

                    }
                }
            }
        }
    }
}